import "./QuienesSomos.css";

function QuienesSomos() {
  return (
    <div className="qs-container">
      {/* 🔥 HERO (VA AQUÍ ARRIBA) */}
      <div className="qs-hero">
        <h1>SINTRASECSALUD</h1>
        <p>Comprometidos con la dignidad laboral del sector salud</p>
      </div>

      <div className="qs-card">
        <h2 className="qs-title">Misión</h2>
        <p className="qs-text">
          Representar, proteger y promover de manera integral los derechos
          laborales, económicos y humanos de los trabajadores del sector salud
          en Colombia, mediante el ejercicio efectivo de la libertad sindical,
          la negociación colectiva y la defensa jurídica especializada.
          SINTRASECSALUD orienta su actuación a la construcción de condiciones
          de trabajo dignas, justas y equitativas, impulsando el respeto por la
          estabilidad laboral, la remuneración adecuada y el bienestar integral
          de sus afiliados, con fundamento en la autonomía sindical, la
          transparencia organizacional y la unidad como pilares para fortalecer
          la voz colectiva de quienes garantizan l a prestación del servicio
          esencial de salud en el país.
        </p>
      </div>

      <div className="qs-card">
        <h2 className="qs-title">Visión</h2>
        <p className="qs-text">
          Consolidarse como una organización sindical de referencia nacional en
          el sector salud, reconocida por su capacidad de incidencia real en la
          transformación de las condiciones laborales, su solidez institucional
          y su liderazgo en la defensa de los derechos de los trabajadores. Para
          el año 2030, SINTRASECSALUD proyecta posicionarse como un actor
          determinante en la construcción de políticas laborales justas y
          sostenibles, con presencia efectiva en todo el territorio nacional,
          fortalecimiento permanente de sus estructuras organizativas y
          desarrollo de estrategias innovadoras en formación sindical,
          negociación colectiva y defensa jurídica, contribuyendo de manera
          directa a un sistema de salud más humano, eficiente y respetuoso de la
          dignidad laboral.
        </p>
      </div>
    </div>
  );
}

export default QuienesSomos;
